module.exports = __webpack_public_path__ + "static/img/iot3.a986866.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/iot3.png
// module id = vmTb
// module chunks = 0